import { render, staticRenderFns } from "./ModalTriagem.vue?vue&type=template&id=4c8fc90e&scoped=true"
import script from "./ModalTriagem.vue?vue&type=script&lang=ts"
export * from "./ModalTriagem.vue?vue&type=script&lang=ts"
import style0 from "./ModalTriagem.vue?vue&type=style&index=0&id=4c8fc90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fc90e",
  null
  
)

export default component.exports